// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "3decf978c44ded1540e902821161663f73c6a915/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};